import {
  DashboardOutlined,
  DatabaseOutlined,
  ShoppingCartOutlined,
  DollarOutlined,
  ExperimentOutlined,
  AccountBookOutlined,
  BarChartOutlined,
  SettingOutlined,
  InboxOutlined,
} from "@ant-design/icons";

const iconMap = {
  dashboard: <DashboardOutlined />,
  masterData: <DatabaseOutlined />,
  purchasing: <ShoppingCartOutlined />,
  sales: <DollarOutlined />,
  production: <ExperimentOutlined />,
  inventory: <InboxOutlined />,
  accounts: <AccountBookOutlined />,
  reports: <BarChartOutlined />,
  administrator: <SettingOutlined />,
};

export default iconMap;
